module.exports = __webpack_public_path__ + "img/cecil-calvert.2ed4a3c8.png";